import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { EcaSecurityService } from '@drc-eca/eca-components-lib';
import { map, take } from 'rxjs/operators';
import { LocalSecurityService } from '../services/shared/local-security.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard implements CanActivate, CanLoad {
  private router = inject(Router);
  private ecaSecurityService = inject(EcaSecurityService);
  private localSecuritySvc = inject(LocalSecurityService);

  constructor() { }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkLoggedIn();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canLoad(route: Route): Observable<boolean> {
        return this.checkLoggedIn();
    }

    checkLoggedIn(): Observable<boolean> {
        return this.ecaSecurityService.isUserLoggedIn.pipe(
            take(1), 
            map(loginState => {
                if (!loginState) {
                    this.router.navigate(['/status/login']);
                    return false;

                } else {                    
                    return true;
                }

            }));
    }
}
